import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const fileUploadConverter = {
  toPm: {
    types: [Node_Type.FILE],
    // @ts-ignore $TSFixMe
    convert: (node) => ({
      type: Node_Type.FILE,
      attrs: {
        ...node.fileData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.FILE],
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.FILE,
        id,
        nodes: [],
        fileData: {
          ...data
        }
      };
    }
  }
};
export {
  fileUploadConverter
};
//# sourceMappingURL=file-upload-converter.js.map
